import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcEmailIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { useScrollToMentionPresenter } from './ScrollToMentionButton.presenter';
import styles from './ScrollToMentionButton.styles.m.css';

export const ScrollToMentionButton: FC = observer(() => {
  const presenter = useScrollToMentionPresenter();

  if (!presenter.hasScrollToMentionButton) {
    return null;
  }

  return (
    <FAB
      className={styles.button}
      size={'30'}
      onClick={presenter.moveToMention}
      badge={presenter.badgeCount}
      Icon={IcEmailIcon}
    />
  );
});
